import React, { useState, FC} from 'react'
import "./EnterpriseQuoteRequestPayNow.scss"

import { Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';  
import cartService from '../../../../../../Services/cartService';
import { savePaymentType } from '../../../../../../Helpers/savePaymentType';

interface propsType {
  orderDetails: any, 
  orderid:any, 
  onHide:any,
  module?: string,
  show: boolean
}
const EnterpriseQuoteRequestPayNow:FC<propsType> = ({module, orderDetails, orderid, onHide, show}) => {
 
  const navigate = useNavigate()
  const [fields, updateFields] = useState({ password: "", paymentVariant: "", locationUuid: "" })
  const [loadingOrder, setLoadingOrder] = useState<boolean>()

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    
    updateFields({
      ...fields,
      [name]: value,
    })
  }

  const onSubmit = async () => {
    const deliveryAddressUuid = orderDetails.orderReceiveType === "DELIVERY" ? { deliveryAddressUuid: orderDetails.deliverAddressUuid } : {}
    const locationUuid =  orderDetails.orderReceiveType === "PICKUP" ? { locationUuid: orderDetails.sellerPickupLocation?.uuid } : {}

    setLoadingOrder(true)

    await cartService.deliveryDetailsQuoteReq(
      { 
        orderReceiveType: orderDetails.orderReceiveType,
        ...locationUuid,
        ...deliveryAddressUuid
      },
      orderid,
      fields.paymentVariant
    ).then(async (res:any) => {
      setLoadingOrder(false)  

      if (res.data.data.paymentTransactionStatus === "paid") {
       return navigate("/buyer/my-orders", {replace:true})

      } else if (res.data.data.paymentTransactionStatus === "unpaid" || fields.paymentVariant === "PAY_ON_DELIVERY") {
       return navigate("/buyer/my-orders", {replace:true})

      } else {
 
        await savePaymentType("CORPORATE_QUOTE_PAYMENT").then(async ()=>{
           window.location.href = res.data.data.paymentProviderDetails.paymentProviderRedirectUrl;
        })

      }
      return onHide
    }, (error:any) => {
      setLoadingOrder(false) 
      toast.error(error.response.data.error, { duration: 20000, className: 'custom-alert bg-white text-dark', position: "top-right" });
    })
  }

  return (
        <Modal 
          show={show}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="eqrPayModal"
          onHide={onHide} 
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Select Payment Option
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <form>
  
          <div>Payment Option <span className='text-danger fw-bolder'>*</span></div>
            <div className="form-group my-3">
            <select className="form-control" onChange={handleChange}
                    name="paymentVariant">
                <option>--choose payment method--</option>
                <option value="WALLET">Wallet</option>
                <option value="CARD">Card</option>
                <option value="PAY_ON_DELIVERY">Pay On Delivery</option>
            </select>
            </div>

            {/* <div>Enter your login password<span className='text-danger fw-bolder'>*</span></div> */}
            {/* <div><b>Security check</b> <span className='text-danger fw-bolder'>*</span></div> */}
            {/* <div className="form-group mb-3">
            <input className="form-control" placeholder="Password" onChange={handleChange}
                    name="password" type="password"/>
            </div> */}
 

            </form>
          </Modal.Body>
          <Modal.Footer>

            {!loadingOrder && <Button className={module && module==='estate' ? "btn btn-primary-estate w-100 rounded" : "btn btn-primary w-100 rounded"} onClick={() => onSubmit()}  disabled={!fields.paymentVariant} type="submit">Pay Now</Button>}
            {loadingOrder && <Button className={module && module==='estate'? "btn btn-primary-estate w-100 rounded disabled": "btn btn-primary w-100 rounded disabled"} type="button" disabled={true}>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            please wait...
            </Button>}
          </Modal.Footer>
        </Modal>
  );
}

export default EnterpriseQuoteRequestPayNow
